import React from "react";
import TipoChavePixService from "../../services/TipoChavePixService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaTipoChavePix extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: TipoChavePixService,
            labels: {
                title: 'Lista de Tipo(s) de Chave Pix',
                btnNewRegister: 'Tipo de Chave Pix',
            },
            keyItem: 'idTipoChavePix',
            urlForm: '/CadTipoChavePix',
            itensFilter: ["idTipoChavePix", "nome"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-2 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-10"> Nome </th>
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idTipoChavePix}</td>
                <td>{item.nome}</td>
            </>);
    }

    render() {
        return super.render();
    }
}